import React from 'react';

import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogTitle,
  ActionableDialogContent,
  ActionableDialogActions,
  ContainerProps,
} from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import copy from 'clipboard-copy';

export interface ShareDialogProps extends ContainerProps {
  url: string;
}

const strings = createStrings({
  ja: {
    title: '運送状況を共有する',
    copyLink: 'リンクをコピーする',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexInline,
  },
  input: {
    flex: 1,
    borderRadius: '4px 0 0 4px',
    borderColor: theme.palette.grey[300],
    borderStyle: 'solid',
    borderWidth: 1,
    marginRight: -5,
    padding: '7px 11px',
  },
}));

export const ShareDialog: React.FC<ShareDialogProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { url, ...rest } = props;
  const handleCopy = () => {
    copy(url);
  };

  return (
    <ActionableDialog {...rest}>
      <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
      <ActionableDialogContent>
        <div className={classes.container}>
          <input className={classes.input} value={url} readOnly />
          <Button
            color="primary"
            text={strings.copyLink}
            size="small"
            style={{ whiteSpace: 'nowrap' }}
            onClick={handleCopy}
          />
        </div>
      </ActionableDialogContent>
      <ActionableDialogActions />
    </ActionableDialog>
  );
};
